import { CLOSE_INPAGE_MODAL, DELETE_MODULE_FROM_PARENT, DELETE_SECTION_FROM_PARENT, OPEN_INPAGE_MODAL, SELECT_IS_SINGLE_COLUMN_FULL_WIDTH_FROM_PARENT } from 'EmailEditorUI/redux/actions/inpageActionTypes';
import { deleteDefinitionCriteria } from 'smart-content-core/actions/Definitions';
export const deleteSection = (index, modules) => ({
  type: DELETE_SECTION_FROM_PARENT,
  elementIds: modules.map(m => m.id),
  index
});
export const deleteModule = id => ({
  type: DELETE_MODULE_FROM_PARENT,
  id
});
export const deleteSmartModule = (moduleId, definitionId, criteriaIds) => dispatch => {
  dispatch(deleteDefinitionCriteria(definitionId, criteriaIds));
  dispatch(deleteModule(moduleId));
};
export const deleteSectionWithSmartContent = (sectionIndex, modules) => dispatch => {
  modules.forEach(({
    definitionId,
    criteriaIds,
    hasSmartContent
  }) => hasSmartContent && dispatch(deleteDefinitionCriteria(definitionId, criteriaIds)));
  dispatch(deleteSection(sectionIndex, modules));
};
export const setIsSingleColumnFullWidth = enabled => ({
  type: SELECT_IS_SINGLE_COLUMN_FULL_WIDTH_FROM_PARENT,
  enabled
});
export const openInpageModal = (modalType, props = {}) => dispatch => {
  return dispatch({
    type: OPEN_INPAGE_MODAL,
    modalType,
    props,
    iframeOnly: false
  });
};
export const closeInpageModal = () => ({
  type: CLOSE_INPAGE_MODAL
});